// extracted by mini-css-extract-plugin
export default {"resetButton":"l8KHrM7","userInfo":"GYTnNKi","avatar":"R_K2W5W","name":"SbzxDLW","email":"fwThrmm","rightCornerContent":"yFEVZm7"};